
// Categories
export const categoryLoadSuccess = (category) => {
    return { type : 'CATEGORY_LOAD_SUCCESS', payload : { category } }
}
export const categoryLoadFail = () => {
    return { type : 'CATEGORY_LOAD_FAIL' }
}
export const mainCategoryAdded = (id, text) => {
    return { type : 'MAIN_CATEGORY_ADDED', payload : { id, text } }
}
export const mainCategoryRemoved = (id) => {
    return { type : 'MAIN_CATEGORY_REMOVED', payload : { id } }
}
export const mainCategoryChanged = (id, mainCategory) => {
    return { type : 'MAIN_CATEGORY_CHANGED', payload : { id, mainCategory } }
}
export const subCategoryAdded = (id, subCategory) => {
    return { type : 'SUB_CATEGORY_ADDED', payload : { id, subCategory } }
}
export const subCategoryChanged = (id, subCategory) => {
    return {
        type : 'SUB_CATEGORY_CHANGED',
        payload : {
            id,
            subCategory
        }
    }
}
export const subCategoryRemoved = (id) => {
    return {
        type : 'SUB_CATEGORY_REMOVED',
        payload : {
            id 
        }
    }
}

export const mainCategoryLoadSuccess = (categories) => {
    return {
        type : 'MAIN_CATEGORY_LOAD_SUCCESS',
        payload : {
            categories
        }
    }
}
export const subCategoryLoadSuccess = (subCategories) => {
    return {
        type : 'SUB_CATEGORY_LOAD_SUCCESS',
        payload : {
            subCategories
        }
    }
}

export const loadCategory = ()=> {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();

        const category = getState().category;

        const mainCategoryRef = firebase.ref().child('category/mainCategory');
        const subCategoryRef = firebase.ref().child('category/subCategory');

        mainCategoryRef.on('value', (snapshot) => {
            let mainCategories = [];
            snapshot.forEach(main => {
                mainCategories.push({
                    id : main.key, 
                    text: main.val() 
                })
            });
            dispatch(mainCategoryLoadSuccess(mainCategories));
        })

        subCategoryRef.on('value', (snapshot) => {
            let subCategories = [];
            snapshot.forEach(sub => {
                let subCats = [];
                const subVal = sub.val();
                for(let key in subVal){
                    subCats.push({
                        id : key,
                        text : subVal[key]
                    })
                }
                subCategories.push(subCats);
            })
            dispatch(subCategoryLoadSuccess(subCategories));
        })
    }
}
//Products
export const productsLoadSuccess = (products)=> {
    return {
        type : 'PRODUCTS_LOAD_SUCCESS',
        payload : {
            products
        }
    }
}
export const productsLoadFail = ()=> {
    return {
        type : 'PRODUCTS_LOAD_FAIL'
    }
}
export const loadProducts = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const productsRef = firebase.ref().child('products/').orderByChild('order');

        productsRef.on('value', (snapshot)=> {
            //처음 받아 올 때의 인덱스를 기록 해 놓자
            let globalIndex = 0;

            let products = []; 

            snapshot.forEach((product) => {
                products.push({
                    id : product.key,
                    globalIndex,
                    ...product.val()
                });
                globalIndex++;
            })
            dispatch(productsLoadSuccess(products));
        })
    }
} 

//Orders
export const loadOrdersSuccess = (orders) => {
    return {
        type : 'LOAD_ORDERS_SUCCESS',
        payload : {
            orders
        }
    }
}
export const loadOrdersFail = () => {
    return {
        type : 'LOAD_ORDES_FAIL'
    }
}
export const loadOrders = () => {
    return (dispatch, getState, getFirebase) => {
        const rootRef = getFirebase().ref();
        const orderRef = rootRef.child('orders').orderByChild('orderTime/day/date');
        orderRef.on('value', (snapshot) => {
            let orders = [];
            snapshot.forEach(order => {
                orders.push({
                    id: order.key,
                    ...order.val()
                })
            })
            dispatch(loadOrdersSuccess(orders));
        })
    }
}
//Accounts
export const loadAccountsSuccess = (accounts) => {
    return {
        type : 'ACCOUNTS_LOAD_SUCCESS',
        payload : {
            accounts
        }
    }
}
export const loadAccountsFail = () => {
    return {
        type : 'ACCOUNTS_LOAD_FAIL'
    }
}
export const loadAccounts = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();

        const accountsRef = firebase.ref().child('accounts/'); 
        accountsRef.on('value', (snapshot) => {
            let accounts = [];
            snapshot.forEach(account => {
                accounts.push({
                    uid : account.key,
                    ...account.val()
                })
            })
            dispatch(loadAccountsSuccess(accounts));
        })
    }
}
//Articles
export const articlesLoadSuccess = (articles) => {
    return { type : 'ADMIN_ARTICLES_LOAD_SUCCESS' , payload : { articles } }
}
export const articlesLoadFail = () => {
    return { type : 'ADMIN_ARTCLES_LOAD_FAIL' }
}
export const loadArticles = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const articlesRef = firebase.ref().child('articles/');

        articlesRef.orderByChild('date').on('value', (snapshot)=> {
            let articles = []; 
            snapshot.forEach(article => {
                articles.push({
                    id : article.key,
                    ...article.val()
                });
            })
            dispatch(articlesLoadSuccess(articles));
        })
    }
}
//Histories
export const historiesLoadSuccess = (histories) => {
    return {
        type : 'ADMIN_HISTORIES_LOAD_SUCCESS',
        payload : {
            histories
        }
    }
}
export const historiesLoadFail = () => {
    return {
        type : 'ADMIN_HISTORIES_LOAD_FAIL'
    }
}
export const loadHistories = () => {
   return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const historiesRef = firebase.ref().child('histories/');

        historiesRef.orderByChild('year').on('value', (snapshot)=> {
            let histories = []; 
            snapshot.forEach(history => {
                histories.push({
                    id : history.key,
                    ...history.val()
                });
            })
            dispatch(historiesLoadSuccess(histories));
        })
    }
}
//Mains
export const mainsLoadSuccess = (mains) => {
    return {
        type : 'ADMIN_MAINS_LOAD_SUCCESS',
        payload : {
            mains
        }
    }
}
export const mainsLoadFail = () => {
    return {
        type : 'ADMIN_MAINS_LOAD_FAIL'
    }
}
export const loadMains = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const mainsRef = firebase.ref('mains/').orderByChild('order');

        mainsRef.on('value', (snapshot)=> {
            let mains = []; 
            snapshot.forEach(main => {
                mains.push({
                    id : main.key,
                    ...main.val()
                });
            })
            dispatch(mainsLoadSuccess(mains));
        })
    }
}

//Introductions
export const introductionsLoadSuccess = (introductions) => {
    return {
        type : 'ADMIN_INTRODUCTIONS_LOAD_SUCCESS',
        payload : {
            introductions
        }
    }
}
export const introductionsLoadFail = () => {
    return {
        type  : 'ADMIN_INTRODUCTIONS_LOAD_FAIL'
    }
}
export const loadIntroductions = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const introductionsRef = firebase.ref('introductions/').orderByChild('order');

        introductionsRef.on('value', (snapshot)=> {
            let introductions = []; 
            snapshot.forEach(intro => {
                introductions.push({
                    id : intro.key,
                    ...intro.val()
                });
            })
            dispatch(introductionsLoadSuccess(introductions));
        })
    }
}

export const casesLoadSuccess = (cases) => {
    return {
        type : 'ADMIN_CASES_LOAD_SUCCESS',
        payload : {
            cases
        }
    }
}
export const casesLoadFail = () => {
    return {
        type : 'CASES_LOAD_FAIL',
    }
}
export const loadCases = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const casesRef = firebase.ref('cases/').orderByChild('order');
        casesRef.on('value', (snapshot)=> {
            let cases = []; 
            snapshot.forEach(c => {
                cases.push({
                    id : c.key,
                    ...c.val()
                });
            })
            dispatch(casesLoadSuccess(cases));
        })
    }
}

//Load Contacts
export const loadContactsSuccess = (contacts) => {
    return {
        type : 'CONTACTS_LOAD_SUCCESS',
        payload : {
            contacts
        }
    }
}
export const loadContactsFail = () => {
    return {
        type : 'CONTACTS_LOAD_FAIL'
    }
}
export const loadContacts = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();

        const contactsRef = firebase.ref().child('contacts/');
        contactsRef.on('value', (snapshot) => {
            let contacts = [];
            snapshot.forEach(contact => {
                contacts.push({
                    id : contact.key,
                    ...contact.val()
                })
            })
            dispatch(loadContactsSuccess(contacts));
        })
    }
}

//Load Constructions
export const constructionsLoadSuccess = (constructions) => {
    return { type : 'ADMIN_CONSTRUCTIONS_LOAD_SUCCESS', payload : { constructions } }
}
export const constructionsLoadFail = () => {
    return { type : 'ADMIN_CONSTRUCTIONS_LOAD_FAIL' }
}
export const loadConstructions = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const constructionsRef = firebase.ref('departments/constructions/');
        constructionsRef.orderByChild('order').on('value', (snapshot)=> {
            let constructions = []; 
            snapshot.forEach(con => {
                constructions.push({
                    id : con.key,
                    ...con.val()
                });
            })
            dispatch(constructionsLoadSuccess(constructions));
        })
    }
}
//Load Materials
export const materialsLoadSuccess = (materials) => {
    return { type : 'ADMIN_MATERIALS_LOAD_SUCCESS', payload : { materials } }
}
export const materialsLoadFail = () => {
    return { type : 'ADMIN_MATERIALS_LOAD_FAIL' }
}
export const loadMaterials = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const materialsRef = firebase.ref('departments/materials/');
        materialsRef.orderByChild('order').on('value', (snapshot)=> {
            let materials = []; 
            snapshot.forEach(material => {
                materials.push({
                    id : material.key,
                    ...material.val()
                });
            })
            dispatch(materialsLoadSuccess(materials));
        })
    }
}
//Load Fertilizer
export const fertilizersLoadSuccess = (fertilizers) => {
    return { type : 'ADMIN_FERTILIZERS_LOAD_SUCCESS', payload : { fertilizers } }
}
export const fertilizersLoadFail = () => {
    return { type : 'ADMIN_FERTILIZERS_LOAD_FAIL' }
}
export const loadFertilizers = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const fertilizersRef = firebase.ref('departments/fertilizers/');
        fertilizersRef.orderByChild('order').on('value', (snapshot)=> {
            let fertilizers = []; 
            snapshot.forEach(con => {
                fertilizers.push({
                    id : con.key,
                    ...con.val()
                });
            })
            dispatch(fertilizersLoadSuccess(fertilizers));
        })
    }
}
//Load Mediums
export const mediumsLoadSuccess = (mediums) => {
    return { type : 'ADMIN_MEDIUMS_LOAD_SUCCESS', payload : { mediums } }
}
export const mediumsLoadFail = () => {
    return { type : 'ADMIN_MEDIUMS_LOAD_FAIL' }
}
export const loadMediums = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const mediumsRef = firebase.ref('departments/mediums/');
        mediumsRef.orderByChild('order').on('value', (snapshot)=> {
            let mediums = []; 
            snapshot.forEach(con => {
                mediums.push({
                    id : con.key,
                    ...con.val()
                });
            })
            dispatch(mediumsLoadSuccess(mediums));
        })
    }
}
//Load Extras
export const extrasLoadSuccess = (extras) => {
    return { type : 'ADMIN_EXTRAS_LOAD_SUCCESS', payload : { extras } }
}
export const extrasLoadFail = () => {
    return { type : 'ADMIN_EXTRAS_LOAD_FAIL' }
}
export const loadExtras = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const extrasRef = firebase.ref('departments/extras/');
        extrasRef.orderByChild('order').on('value', (snapshot)=> {
            let extras = []; 
            snapshot.forEach(con => {
                extras.push({
                    id : con.key,
                    ...con.val()
                });
            })
            dispatch(extrasLoadSuccess(extras));
        })
    }
}

//Load Department Cards
export const departmentCardsLoadSuccess = (cards) => {
    return { type : 'ADMIN_DEPARTMENT_CARDS_LOAD_SUCCESS', payload : { cards } }
}
export const departmentCardsLoadFail = () => {
    return { type : 'ADMIN_DEPARTMENT_CARDS_LOAD_FAIL' }
}
export const loadDepartmentsCards = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const cardsRef = firebase.ref('departments/cards/');
        cardsRef.on('value', (snapshot)=> {
            let cards = []; 
            snapshot.forEach(con => {
                cards.push({
                    id : con.key,
                    ...con.val()
                });
            })
            dispatch(departmentCardsLoadSuccess(cards));
        }, () => {
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/Admin/actions/adminActions.js